import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormGenerator from '../FormGenerator';

class Step2 extends PureComponent {
  static propTypes = {
    sections: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string.isRequired,
    optionByField: PropTypes.object.isRequired,
    applicants: PropTypes.number.isRequired,
    tabIndex: PropTypes.number.isRequired,
    setTabIndex: PropTypes.func.isRequired,
  };

  renderContent = () => {
    const { hexColorCodeC, sections, optionByField } = this.props;
    const content = [];
    const hasSections = !!Object.keys(sections).length;
    for (let i = 0; i < this.props.applicants; i++) {
      content.push(
        <div
          key={i}
          className={classnames('ui bottom attached tab segment accented', {
            active: this.props.tabIndex === i,
          })}
        >
          {hasSections && (
            <FormGenerator
              form={`member${i + 1}`}
              sections={sections}
              sectionsToRender={['Appearance', 'More About You', 'Experience']}
              hexColorCodeC={hexColorCodeC}
              optionByField={optionByField}
            />
          )}
        </div>
      );
    }
    return content;
  };

  renderTabSections() {
    if (this.props.applicants) {
      const numOfApps = this.props.applicants;
      if (numOfApps >= 2) {
        const tabs = [];
        for (let i = 0; i < numOfApps; i++) {
          tabs.push(
            <div
              key={i}
              className={classnames('item', {
                active: this.props.tabIndex === i,
              })}
              onClick={() => this.props.setTabIndex(i)}
            >
              Member {i + 1}
            </div>
          );
        }

        return (
          <div
            style={{ borderColor: `#${this.props.hexColorCodeC}` }}
            className="ui top attached tabular menu accented"
          >
            {tabs}
          </div>
        );
      }
    }

    return '';
  }

  render() {
    return (
      <div>
        {this.renderTabSections()}
        {this.renderContent()}
		   <div style={{ marginBottom: '10px' }}>

          <p>
          </p>

        </div>
      </div>
    );
  }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/components/apply/Step2.js